import { IQueryContext } from 'src/app/services/query-context/models/IQueryContext';
import {
    DashboardItemComponentType,
    DashboardItemFactory,
    IDashboardItem,
} from 'src/app/utils/dashboard-item';

// export interface IModifyTimeData {
//     value: string[];
// }

// export interface ISegmentDatasourceColumnState extends IQueryContextDatasourceColumnState {
//     value: {
//         options: any[];
//         operator: 'OR' | 'AND';
//     };
// }

export interface IModifyTimeDashboardItem extends IDashboardItem {}

// TODO migrate to interface
export class ModifyTimeDashboardItemFactoryOptions {
    constructor(
        /** Instance id */
        public createdInstanceId: string,
        /** Specify which column from DataLoader should be used
         * @default 'value'
         */
        public columnId: string = 'value'
    ) {}
}

export class ModifyTimeDashboardItemFactory extends DashboardItemFactory<
    IModifyTimeDashboardItem,
    ModifyTimeDashboardItemFactoryOptions
> {
    override FACTORY_CLASS: string = 'ModifyTimeDashboardItemFactory';
    override COMPONENT_CLASS: DashboardItemComponentType =
        'DataTextDashboardItem';

    override getInstance(options: ModifyTimeDashboardItemFactoryOptions) {
        const instance: IModifyTimeDashboardItem = {
            instanceId: options.createdInstanceId,
            dashboardItem: {
                initialState: {
                    value: 'Loading...',
                },
            },
            component: this.COMPONENT_CLASS,
            composeData: (data: any, context?: IQueryContext) => {
                console.log({
                    msg: `[IModifyTimeDashboardItem.composeData]`,
                    data,
                    context,
                });
                return data[options.columnId];
            },
        };

        return instance;
    }
}
